import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress PostHog/third-party script errors that can't be fixed
const originalError = console.error;
console.error = (...args) => {
  if (args[0]?.includes?.('PerformanceServerTiming') || 
      args[0]?.includes?.('posthog') ||
      (typeof args[0] === 'string' && args[0].includes('postMessage'))) {
    return;
  }
  originalError.apply(console, args);
};

// Global error handler for uncaught errors from third-party scripts
window.addEventListener('error', (event) => {
  if (event.message?.includes?.('PerformanceServerTiming') ||
      event.message?.includes?.('postMessage') ||
      event.filename?.includes?.('posthog')) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes?.('PerformanceServerTiming') ||
      event.reason?.message?.includes?.('postMessage')) {
    event.preventDefault();
    event.stopPropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
